export const orders = [
  // pickup with no minimal fees
  {
    coupon: null,
    manualDiscount: null, // ? is this our total discount
    createdAt: '1593617827845',
    credit: 0,
    curbsideArrivalInfo: null,
    durationEstimates: [],
    isAfterHoursOrder: false,
    cannabisTaxExistence: { med: { pos: {}, menu: {}, checkout: {} }, rec: { pos: {}, menu: {}, checkout: {} } },
    salesTaxExistence: { med: { pos: {}, menu: {}, checkout: {} }, rec: { pos: {}, menu: {}, checkout: {} } },
    deliveryFee: 0,
    dispensary: {
      _id: 'SbnMPug4uHJZu5tG3',
      name: 'Oregrown',
      cName: 'oregrown',
      phone: '(248) 014-6738',
      logoImage: null,
      address: '1199 NW Wall St, Bend, OR 97701, USA',
      timezone: 'America/Los_Angeles',
      featureFlags: {
        hideDeliveryEstimate: false,
        __typename: 'Dispensaries_featureFlags',
      },
      __typename: 'Orders_dispensary',
    },
    id: '5efcada39114de7d9678fae7',
    customer: {
      _id: 'tWZGNxWfo6mga5Gd3',
      emails: [
        {
          address: 'user@dutchie.dev',
          __typename: 'Orders_customer_emails',
        },
      ],
      profile: {
        medicalCard: {
          expirationDate: '04/11/2023',
          number: 'vcvbcvbc',
          state: 'OR',
          photo: null,
          __typename: 'Orders_medicalCard',
        },
        driversLicense: null,
        photoId: null,
        firstName: 'Dutchie',
        lastName: 'Dev',
        email: null,
        phone: '(248) 506-7777',
        birthday: '6/14/1986',
        __typename: 'Orders_customer_profile',
      },
      __typename: 'Orders_customer',
    },
    pos: null,
    fleetManagementTask: null,
    guestCustomer: null,
    medicalOrder: false,
    medicalCard: null,
    orderId: '149951030-T',
    orders: [
      {
        basePrice: 56.09, // ? is the discount applied here...?
        option: '3.5g',
        price: 56.09, // ? ... or here?
        product: {
          _id: '5e8cea1b3f37ed0004fea039',
          Name: 'BURNSIDE GARDEN COLLECTIVE | MOONBOW',
          Image: 'https://s3-us-west-2.amazonaws.com/dutchie-images/flower-stock-1-v1.jpg',
          strainType: 'Sativa',
          type: 'Flower',
          Options: ['1g', '3.5g', '7g', '14g', '28g'],
          brandName: 'Burnside Garden Collective',
          THCContent: {
            unit: 'PERCENTAGE',
            value: '28.4',
            range: [28.4],
            __typename: 'ProductPotency',
          },
          CBDContent: {
            unit: 'PERCENTAGE',
            value: '0.26',
            range: [0.26],
            __typename: 'ProductPotency',
          },
          Prices: [17.53, 56.09, 105.18, 168.28, 308.52],
          preTaxRecPrices: [10.42, 33.33, 62.5, 100, 183.33], // ? or maybe i need to grab these from here
          preTaxMedPrices: [10.42, 33.33, 62.5, 100, 183.33],
          __typename: 'Order_product',
        },
        quantity: 1,
        __typename: 'Orders_order',
      },
      {
        basePrice: 8.18,
        option: '.85g',
        price: 8.18,
        product: {
          _id: '5e0665ae20b2fd00034a9a85',
          Name: 'CHOCOLATE GRAPE DIESEL PRE-ROLL | COYOTE CREEK',
          Image: 'https://s3-us-west-2.amazonaws.com/dutchie-images/7c3192fb866de5c7c4785cb21886ba2a',
          strainType: 'Hybrid',
          type: 'Pre-Rolls',
          Options: ['.85g'],
          brandName: 'Coyote Creek',
          THCContent: {
            unit: 'PERCENTAGE',
            value: '23.09',
            range: [23.09],
            __typename: 'ProductPotency',
          },
          CBDContent: null,
          Prices: [8.18],
          preTaxRecPrices: [4.86],
          preTaxMedPrices: [4.86],
          __typename: 'Order_product',
        },
        quantity: 1,
        __typename: 'Orders_order',
      },
    ],
    specialInstructions: '',
    status: 'open',
    statusTimes: null,
    statusEvents: null,
    taxAmount: 26.24, // ? does this include cannabisTax
    cannabisTax: 0,
    tipAmount: 0,
    paymentFee: 0,
    paymentMethod: 'cash',
    subtotal: '38.03',
    totalCost: '64.27',
    isPreviewOrder: true,
    isKioskOrder: false,
    isCurbsidePickupOrder: false,
    isDriveThruPickupOrder: false,
    terminal: null,
    autoConfirmed: false,
    autoClosed: false,
    driverName: null,
    driverNumber: null,
    deliveryInfo: {
      address: '3000 Hilyard St, Eugene, OR 97405',
      apartmentNum: null,
      deliveryAddress: null,
      deliveryOption: false, // ? this is what we determine pickup vs delivery with right?
      lastSearchedAddress: null,
      nonDeliveryAddress: null,
      location: {
        lat: 44.02469259999999,
        lng: -123.0816404,
        ln1: '3000 Hilyard St',
        ln2: '',
        city: 'Eugene',
        state: 'OR',
        zipcode: '97405',
        __typename: 'Orders_location',
      },
      __typename: 'Orders_deliveryInfo',
    },
    editEvents: null,
    isArchived: false,
    archivedBy: null,
    archivedAtISO: null,
    cancellationReason: null,
    updatedAt: '1593617828000',
    hypur: null,
    paysafe: null,
    appliedRewards: [],
    reservation: null,
    __typename: 'Orders',
  },
  // delivery with some taxes and fees
  {
    coupon: null,
    manualDiscount: 0,
    createdAt: '1593701849751',
    credit: 0,
    curbsideArrivalInfo: null,
    deliveryFee: 10,
    dispensary: {
      _id: 'SbnMPug4uHJZu5tG3',
      name: 'Oregrown',
      cName: 'oregrown',
      phone: '(248) 914-6738',
      logoImage: null,
      address: '1199 NW Wall St, Bend, OR 97701, USA',
      timezone: 'America/Los_Angeles',
      featureFlags: {
        hideDeliveryEstimate: false,
        __typename: 'Dispensaries_featureFlags',
      },
      __typename: 'Orders_dispensary',
    },
    id: '5efdf5d9c8452877f7b80cee',
    customer: {
      _id: 'tWZGNxWfo6mga5Gd3',
      emails: [
        {
          address: 'user@dutchie.dev',
          __typename: 'Orders_customer_emails',
        },
      ],
      profile: {
        medicalCard: {
          expirationDate: '04/11/2023',
          number: 'vcvbcvbc',
          state: 'OR',
          photo: null,
          __typename: 'Orders_medicalCard',
        },
        driversLicense: null,
        photoId: null,
        firstName: 'Dutchie',
        lastName: 'Dev',
        email: null,
        phone: '(248) 506-7777',
        birthday: '6/14/1986',
        __typename: 'Orders_customer_profile',
      },
      __typename: 'Orders_customer',
    },
    pos: null,
    fleetManagementTask: null,
    guestCustomer: null,
    medicalOrder: false,
    medicalCard: null,
    orderId: '844966489',
    orders: [
      {
        basePrice: 35.06,
        option: '3.5g',
        price: 35.06,
        product: {
          _id: '5da8b660539f42000399f145',
          Name: 'OREGROWN | HIGH DESERT SOUR SAGE',
          Image: 'https://s3-us-west-2.amazonaws.com/dutchie-images/c3dd050830caee3095e35753cc54c533',
          strainType: 'Sativa',
          type: 'Flower',
          Options: ['1g', '3.5g', '7g', '14g', '28g'],
          brandName: 'Oregrown',
          THCContent: {
            unit: 'PERCENTAGE',
            value: '20.8',
            range: [20.8],
            __typename: 'ProductPotency',
          },
          CBDContent: {
            unit: 'PERCENTAGE',
            value: '0.08',
            range: [0.08],
            __typename: 'ProductPotency',
          },
          Prices: [11.68, 35.06, 70.12, 126.21, 245.42],
          preTaxRecPrices: [6.94, 20.83, 41.67, 75, 145.83],
          preTaxMedPrices: [6.94, 20.83, 41.67, 75, 145.83],
          __typename: 'Order_product',
        },
        quantity: 1,
        __typename: 'Orders_order',
      },
      {
        basePrice: 56.09,
        option: '.5g',
        price: 56.09,
        product: {
          _id: '5e99022b5ec3b3000474cb7b',
          Name: 'Happy Cabbage | Rosin Cartridge | Cookie Dawg',
          Image: 'https://s3-us-west-2.amazonaws.com/dutchie-images/concentrates-stock-rosin-v1.jpg',
          strainType: 'N/A',
          type: 'Concentrate',
          Options: ['.5g'],
          brandName: 'Happy Cabbage Rosin Cartridge',
          THCContent: null,
          CBDContent: null,
          Prices: [56.09],
          preTaxRecPrices: [33.33],
          preTaxMedPrices: [33.33],
          __typename: 'Order_product',
        },
        quantity: 1,
        __typename: 'Orders_order',
      },
    ],
    specialInstructions: 'ring the bell',
    status: 'open',
    statusTimes: null,
    statusEvents: null,
    taxAmount: 37.21,
    cannabisTax: 12.22,
    tipAmount: 22.79,
    paymentFee: 0,
    paymentMethod: 'creditCardByPhone',
    subtotal: '53.94',
    totalCost: '123.94',
    isPreviewOrder: false,
    isKioskOrder: false,
    isCurbsidePickupOrder: false,
    isDriveThruPickupOrder: false,
    terminal: null,
    autoConfirmed: false,
    autoClosed: false,
    driverName: null,
    driverNumber: null,
    deliveryInfo: {
      address: '3000 Hilyard St, Eugene, OR 97405',
      apartmentNum: null,
      deliveryAddress: null,
      deliveryOption: true,
      lastSearchedAddress: null,
      nonDeliveryAddress: null,
      location: {
        lat: 44.02469259999999,
        lng: -123.0816404,
        ln1: '3000 Hilyard St',
        ln2: '',
        city: 'Eugene',
        state: 'OR',
        zipcode: '97405',
        __typename: 'Orders_location',
      },
      __typename: 'Orders_deliveryInfo',
    },
    editEvents: null,
    isArchived: false,
    archivedBy: null,
    archivedAtISO: null,
    cancellationReason: null,
    updatedAt: '1593701849810',
    hypur: null,
    paysafe: null,
    appliedRewards: [],
    reservation: null,
    __typename: 'Orders',
  },
  // lots of products for curbside pickup
  {
    coupon: null,
    manualDiscount: null,
    createdAt: '1593709061523',
    credit: 0,
    curbsideArrivalInfo: null,
    deliveryFee: 0,
    dispensary: {
      _id: 'SbnMPug4uHJZu5tG3',
      name: 'Oregrown',
      cName: 'oregrown',
      phone: '(248) 914-6738',
      logoImage: null,
      address: '1199 NW Wall St, Bend, OR 97701, USA',
      timezone: 'America/Los_Angeles',
      featureFlags: {
        hideDeliveryEstimate: false,
        __typename: 'Dispensaries_featureFlags',
      },
      __typename: 'Orders_dispensary',
    },
    id: '5efe1205c8452877f7b80cef',
    customer: {
      _id: 'tWZGNxWfo6mga5Gd3',
      emails: [
        {
          address: 'user@dutchie.dev',
          __typename: 'Orders_customer_emails',
        },
      ],
      profile: {
        medicalCard: {
          expirationDate: '04/11/2023',
          number: 'vcvbcvbc',
          state: 'OR',
          photo: null,
          __typename: 'Orders_medicalCard',
        },
        driversLicense: null,
        photoId: null,
        firstName: 'Dutchie',
        lastName: 'Dev',
        email: null,
        phone: '(248) 506-7777',
        birthday: '6/14/1986',
        __typename: 'Orders_customer_profile',
      },
      __typename: 'Orders_customer',
    },
    pos: null,
    fleetManagementTask: null,
    guestCustomer: null,
    medicalOrder: false,
    medicalCard: null,
    orderId: '94767946',
    orders: [
      {
        basePrice: 11.68,
        option: '1g',
        price: 23.36,
        product: {
          _id: '5dbb690c6ec821000376f31e',
          Name: 'EAST FORK CULTIVARS | BUBBA KUSH',
          Image: 'https://s3-us-west-2.amazonaws.com/dutchie-images/b3a098537ab5e725ff9d870f092057f2',
          strainType: 'High CBD',
          type: 'Flower',
          Options: ['1g', '3.5g', '7g', '14g', '28g'],
          brandName: 'East Fork Cultivars',
          THCContent: {
            unit: 'PERCENTAGE',
            value: '6.93',
            range: null,
            __typename: 'ProductPotency',
          },
          CBDContent: {
            unit: 'PERCENTAGE',
            value: '15.4',
            range: null,
            __typename: 'ProductPotency',
          },
          Prices: [11.68, 35.06, 70.12, 126.21, 245.42],
          preTaxRecPrices: [6.94, 20.83, 41.67, 75, 145.83],
          preTaxMedPrices: [6.94, 20.83, 41.67, 75, 145.83],
          __typename: 'Order_product',
        },
        quantity: 2,
        __typename: 'Orders_order',
      },
      {
        basePrice: 8.18,
        option: '.85g',
        price: 8.18,
        product: {
          _id: '5e0665ae20b2fd00034a9a85',
          Name: 'CHOCOLATE GRAPE DIESEL PRE-ROLL | COYOTE CREEK',
          Image: 'https://s3-us-west-2.amazonaws.com/dutchie-images/7c3192fb866de5c7c4785cb21886ba2a',
          strainType: 'Hybrid',
          type: 'Pre-Rolls',
          Options: ['.85g'],
          brandName: 'Coyote Creek',
          THCContent: {
            unit: 'PERCENTAGE',
            value: '23.09',
            range: [23.09],
            __typename: 'ProductPotency',
          },
          CBDContent: null,
          Prices: [8.18],
          preTaxRecPrices: [4.86],
          preTaxMedPrices: [4.86],
          __typename: 'Order_product',
        },
        quantity: 1,
        __typename: 'Orders_order',
      },
      {
        basePrice: 6.31,
        option: '.5g',
        price: 6.31,
        product: {
          _id: '5e85162e303ca90004b54501',
          Name: 'HAPPYLUCKY PRE-ROLL | EAST FORK CULTIVARS',
          Image: 'https://s3-us-west-2.amazonaws.com/dutchie-images/preroll-stock-1-v1.jpg',
          strainType: 'High CBD',
          type: 'Pre-Rolls',
          Options: ['.5g'],
          brandName: 'East Fork Cultivars',
          THCContent: {
            unit: 'PERCENTAGE',
            value: '4.05',
            range: [4.05],
            __typename: 'ProductPotency',
          },
          CBDContent: {
            unit: 'PERCENTAGE',
            value: '12.3',
            range: [12.3],
            __typename: 'ProductPotency',
          },
          Prices: [6.31],
          preTaxRecPrices: [3.75],
          preTaxMedPrices: [3.75],
          __typename: 'Order_product',
        },
        quantity: 1,
        __typename: 'Orders_order',
      },
      {
        basePrice: 6.31,
        option: '.5g',
        price: 6.31,
        product: {
          _id: '5e850f2476d7b00004fc71d3',
          Name: 'OREGON GUAVA PRE-ROLL | EAST FORK CULTIVARS',
          Image: 'https://s3-us-west-2.amazonaws.com/dutchie-images/preroll-stock-3-v1.jpg',
          strainType: 'High CBD',
          type: 'Pre-Rolls',
          Options: ['.5g'],
          brandName: 'East Fork Cultivars',
          THCContent: {
            unit: 'PERCENTAGE',
            value: '1.1',
            range: [1.1],
            __typename: 'ProductPotency',
          },
          CBDContent: {
            unit: 'PERCENTAGE',
            value: '15.1',
            range: [15.1],
            __typename: 'ProductPotency',
          },
          Prices: [6.31],
          preTaxRecPrices: [3.75],
          preTaxMedPrices: [3.75],
          __typename: 'Order_product',
        },
        quantity: 1,
        __typename: 'Orders_order',
      },
      {
        basePrice: 56.09,
        option: '.5g',
        price: 56.09,
        product: {
          _id: '5e99022b5ec3b3000474cb7b',
          Name: 'Happy Cabbage | Rosin Cartridge | Cookie Dawg',
          Image: 'https://s3-us-west-2.amazonaws.com/dutchie-images/concentrates-stock-rosin-v1.jpg',
          strainType: 'N/A',
          type: 'Concentrate',
          Options: ['.5g'],
          brandName: 'Happy Cabbage Rosin Cartridge',
          THCContent: null,
          CBDContent: null,
          Prices: [56.09],
          preTaxRecPrices: [33.33],
          preTaxMedPrices: [33.33],
          __typename: 'Order_product',
        },
        quantity: 1,
        __typename: 'Orders_order',
      },
      {
        basePrice: 70.12,
        option: '1g',
        price: 70.12,
        product: {
          _id: '5d9ba345be4e1f00032874a3',
          Name: 'Happy Cabbage | Layer Cake Rosin Batter | 1g',
          Image: 'https://s3-us-west-2.amazonaws.com/dutchie-images/27bdb33e6820f800a95b20f45fff2713',
          strainType: 'Indica',
          type: 'Concentrate',
          Options: ['1g'],
          brandName: 'Happy Cabbage Farms',
          THCContent: {
            unit: 'PERCENTAGE',
            value: '60.45',
            range: [60.45],
            __typename: 'ProductPotency',
          },
          CBDContent: {
            unit: 'PERCENTAGE',
            value: '0.43',
            range: [0.43],
            __typename: 'ProductPotency',
          },
          Prices: [70.12],
          preTaxRecPrices: [41.67],
          preTaxMedPrices: [41.67],
          __typename: 'Order_product',
        },
        quantity: 1,
        __typename: 'Orders_order',
      },
      {
        basePrice: 49.08,
        option: '1g',
        price: 49.08,
        product: {
          _id: '5ea76d89a1704a000456aabd',
          Name: 'Golden Goose - Strawberry Cough 3:1 CBD:THC Cartridge',
          Image: 'https://s3-us-west-2.amazonaws.com/dutchie-images/concentrates-stock-liveresin-v1.jpg',
          strainType: 'N/A',
          type: 'Concentrate',
          Options: ['1g'],
          brandName: 'Golden Goose',
          THCContent: null,
          CBDContent: null,
          Prices: [49.08],
          preTaxRecPrices: [29.17],
          preTaxMedPrices: [29.17],
          __typename: 'Order_product',
        },
        quantity: 1,
        __typename: 'Orders_order',
      },
      {
        basePrice: 16.83,
        option: 'N/A',
        price: 16.83,
        product: {
          _id: '5e71783d097e860004dc6ea0',
          Name: 'WAYFARER | SUNGLASSES',
          Image: 'https://s3-us-west-2.amazonaws.com/dutchie-images/accessories.jpg',
          strainType: 'N/A',
          type: 'Accessories',
          Options: ['N/A'],
          brandName: 'Oregrown Lifestyle',
          THCContent: null,
          CBDContent: null,
          Prices: [16.83],
          preTaxRecPrices: [10],
          preTaxMedPrices: [10],
          __typename: 'Order_product',
        },
        quantity: 1,
        __typename: 'Orders_order',
      },
    ],
    specialInstructions: '',
    status: 'open',
    statusTimes: null,
    statusEvents: null,
    taxAmount: 96.48,
    cannabisTax: 4.2,
    tipAmount: 0,
    paymentFee: 0,
    paymentMethod: 'creditCardByPhone',
    subtotal: '139.80',
    totalCost: '236.28',
    isPreviewOrder: false,
    isKioskOrder: false,
    isCurbsidePickupOrder: true,
    isDriveThruPickupOrder: false,
    terminal: null,
    autoConfirmed: false,
    autoClosed: false,
    driverName: null,
    driverNumber: null,
    deliveryInfo: {
      address: '',
      apartmentNum: null,
      deliveryAddress: null,
      deliveryOption: false,
      lastSearchedAddress: null,
      nonDeliveryAddress: null,
      location: {
        lat: null,
        lng: null,
        ln1: null,
        ln2: null,
        city: null,
        state: null,
        zipcode: null,
        __typename: 'Orders_location',
      },
      __typename: 'Orders_deliveryInfo',
    },
    editEvents: null,
    isArchived: false,
    archivedBy: null,
    archivedAtISO: null,
    cancellationReason: null,
    updatedAt: '1593709061625',
    hypur: null,
    paysafe: null,
    appliedRewards: [],
    reservation: null,
    __typename: 'Orders',
  },
  // discounted item
  {
    coupon: {
      _id: '5efe14f8c8452877f7b80cf2',
      active: true,
      addedDate: '1593709816369',
      amount: null,
      percentDiscount: null,
      fixedDiscountInCents: 420,
      code: 'butts',
      dispensary: null,
      expDate: '1880211600000',
      numAllowedUses: null,
      numUses: 0,
      usedBy: null,
      __typename: 'Coupons',
    },
    manualDiscount: null,
    createdAt: '1593709845414',
    credit: 0,
    curbsideArrivalInfo: null,
    deliveryFee: 0,
    dispensary: {
      _id: 'SbnMPug4uHJZu5tG3',
      name: 'Oregrown',
      cName: 'oregrown',
      phone: '(248) 914-6738',
      logoImage: null,
      address: '1199 NW Wall St, Bend, OR 97701, USA',
      timezone: 'America/Los_Angeles',
      featureFlags: {
        hideDeliveryEstimate: false,
        __typename: 'Dispensaries_featureFlags',
      },
      __typename: 'Orders_dispensary',
    },
    id: '5efe1515c8452877f7b80cf3',
    customer: {
      _id: 'tWZGNxWfo6mga5Gd3',
      emails: [
        {
          address: 'user@dutchie.dev',
          __typename: 'Orders_customer_emails',
        },
      ],
      profile: {
        medicalCard: {
          expirationDate: '04/11/2023',
          number: 'vcvbcvbc',
          state: 'OR',
          photo: null,
          __typename: 'Orders_medicalCard',
        },
        driversLicense: null,
        photoId: null,
        firstName: 'Dutchie',
        lastName: 'Dev',
        email: null,
        phone: '(248) 506-7777',
        birthday: '6/14/1986',
        __typename: 'Orders_customer_profile',
      },
      __typename: 'Orders_customer',
    },
    pos: null,
    fleetManagementTask: null,
    guestCustomer: null,
    medicalOrder: false,
    medicalCard: null,
    orderId: '619311064',
    orders: [
      {
        basePrice: 17.53,
        option: '1g',
        price: 17.53,
        product: {
          _id: '5e98c79fa19281000446e41d',
          Name: 'BURNSIDE GARDEN COLLECTIVE | HAZMAT OG',
          Image: 'https://s3-us-west-2.amazonaws.com/dutchie-images/flower-stock-1-v1.jpg',
          strainType: 'Indica',
          type: 'Flower',
          Options: ['1g', '3.5g', '7g', '14g', '28g'],
          brandName: 'Burnside Garden Collective',
          THCContent: {
            unit: 'PERCENTAGE',
            value: '22.1',
            range: [22.1],
            __typename: 'ProductPotency',
          },
          CBDContent: null,
          Prices: [17.53, 56.09, 105.18, 168.28, 308.52],
          preTaxRecPrices: [10.42, 33.33, 62.5, 100, 183.33],
          preTaxMedPrices: [10.42, 33.33, 62.5, 100, 183.33],
          __typename: 'Order_product',
        },
        quantity: 1,
        __typename: 'Orders_order',
      },
    ],
    specialInstructions: '',
    status: 'open',
    statusTimes: null,
    statusEvents: null,
    taxAmount: 4.26,
    cannabisTax: 0,
    tipAmount: 0,
    paymentFee: 0,
    paymentMethod: 'creditCardByPhone',
    subtotal: '6.17',
    totalCost: '10.43',
    isPreviewOrder: false,
    isKioskOrder: false,
    isCurbsidePickupOrder: false,
    isDriveThruPickupOrder: false,
    terminal: null,
    autoConfirmed: false,
    autoClosed: false,
    driverName: null,
    driverNumber: null,
    deliveryInfo: {
      address: '',
      apartmentNum: null,
      deliveryAddress: null,
      deliveryOption: false,
      lastSearchedAddress: null,
      nonDeliveryAddress: null,
      location: {
        lat: null,
        lng: null,
        ln1: null,
        ln2: null,
        city: null,
        state: null,
        zipcode: null,
        __typename: 'Orders_location',
      },
      __typename: 'Orders_deliveryInfo',
    },
    editEvents: null,
    isArchived: false,
    archivedBy: null,
    archivedAtISO: null,
    cancellationReason: null,
    updatedAt: '1593709845443',
    hypur: null,
    paysafe: null,
    appliedRewards: [],
    reservation: null,
    __typename: 'Orders',
  },
];
